import React from 'react';
import BaseValidator from 'services/validations/base-validator';

class MinTiersValidator extends BaseValidator {
    protected runValidation(): void {
        if (this.isTiersQuantityEnough()) {
            return;
        }

        this.addError('All of tiers have to contain at least 1 player.');
    }

    private isTiersQuantityEnough(): boolean {
        // @ts-ignore
        const {sportConfig, slates} = this.dependencies;

        const slate = slates.getById(sportConfig.getSlateId());

        const playersInLineup = slate.tiers_quantity || 0;

        return this.calcTiersQuantity() >= playersInLineup;
    }

    private calcTiersQuantity(): number {
        // @ts-ignore
        const {players} = this.dependencies;

        const tiersMap = {};
        players.getAllAsArr().map((player) => {
            player.rosterPosition.map((rosterPosition) => {
                tiersMap[rosterPosition] = true;
            });
        });

        return Object.keys(tiersMap).length;
    }
}

export {MinTiersValidator};
